import HiFive from "../../assets/icons/HiFive";
import useRetailBusinessStatus from "../../hooks/invoice/useRetailBusinessStatus";
import { useUserStore } from "../../state";
import TourGuideComponent from "./SideBar";

export const useCreateInvoiceTourGuide = () => {
  const isRetailBusiness = useRetailBusinessStatus();
  const { user, setListInvoice, updateProfile } = useUserStore();
  const tourGuideOptions = {
    showProgress: false,
    styles: {
      tooltip: { background: "#ffffff" },
      beaconInner: { background: "#ffffff" },
    },
    locale: {
      skip: (
        <span
          onClick={() => {
            updateProfile({
              prefs: {
                ...user.prefs,
                isFirstInvoice: false,
              },
            });
          }}
          className="text-[#344054]"
        >
          Skip
        </span>
      ),
      next: <span className="text-[#ffffff] bg-transparent">Next</span>,
      disableScrolling: false,
      scrollOffset: 80,
    },
  };
  const createInvoiceTourGuide = [
    {
      target: "#personalize-invoice",
      content: (
        <TourGuideComponent
          body="Personalize your invoices by adding your company logo, name, address, phone number, and RC number."
          progress="Step 1 of 4"
          title="Personalize Your Invoice"
        />
      ),
      hideBackButton: true,
      scrollOffset: 80,
      placement: "right" as const,
      ...tourGuideOptions,
    },
    {
      target: "#add-customer",
      content: (
        <TourGuideComponent
          body="Click the add button to select an existing customer from your list or quickly add a new one."
          progress="Step 2 of 4"
          title="Add Customer"
        />
      ),
      placement: "right" as const,
      ...tourGuideOptions,
    },
    {
      target: "#line-table",
      content: (
        <TourGuideComponent
          body="Add the products or services you’re billing for"
          progress="Step 3 of 4"
          title="Add Items"
        />
      ),
      placement: "top" as const,
      ...tourGuideOptions,
    },
    {
      target: "#add-bank",
      content: (
        <TourGuideComponent
          body="Click the add button to add your bank details for easy billing"
          progress="Step 4 of 4"
          title="Add Bank"
        />
      ),
      placement: "right" as const,
      disableScrolling: false,
      locale: {
        skip: <span className="text-[#344054]">Skip</span>,
        next: <span className="text-[#ffffff] bg-transparent">Next</span>,
        last: (
          <span
            onClick={() => {
              updateProfile({
                prefs: {
                  ...user.prefs,
                  isFirstInvoice: false,
                },
              });
            }}
            className="text-[#ffffff] bg-transparent"
          >
            Finish up
          </span>
        ),
      },
      showProgress: false,
      scrollOffset: 80,
      styles: {
        tooltip: { background: "#ffffff" },
        beaconInner: { background: "#ffffff" },
      },
    },
  ];

  return { createInvoiceTourGuide };
};
